import { render } from "./areaEvaAgeEchart.vue?vue&type=template&id=38ca93ef&scoped=true"
import script from "./areaEvaAgeEchart.vue?vue&type=script&lang=js"
export * from "./areaEvaAgeEchart.vue?vue&type=script&lang=js"

import "./areaEvaAgeEchart.vue?vue&type=style&index=0&id=38ca93ef&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ca93ef"]])

export default __exports__